import type MenuI from '@/types/Navigation/MenuI'
import type MenuItemI from '@/types/Navigation/MenuItemI'
import fetchGql from '@/utils/fetchGql'
import { useCacheStorage } from '@/composables/useSessionStorage'
import getSharedMenuItems from '@/gql/getSharedMenuItems.gql'
import type { GetSharedMenuItemsQueryVariables } from '@/gqlTypes/types'

const { getCache } = useCacheStorage()

const getMenuData = (item: MenuItemI, locale: string) => {
  let target = '_self'

  const itemUrl = item.redirect?.story?.full_slug ?? item.redirect?.url
  if (item.redirect?.target) {
    target = item.redirect.target
  }

  const dataLayerData = {
    title: item.redirect?.story?.name || item.dataLayerTitle || '',
    slug: item.redirect?.story?.slug || item.dataLayerSlug || ''
  }

  const data = {
    title: item.title,
    key: formatSbPath(itemUrl, locale) || '/',
    target,
    enData: {
      name: dataLayerData.title,
      slug: dataLayerData.slug
    }
  }

  return data
}

const parseData = (data: any, locale: string) => {
  const result: MenuI[] = []

  data[0].content.items.forEach((menuItem: MenuItemI) => {
    result.push({
      ...getMenuData(menuItem, locale)
    })
  })

  return result
}

export const useFetchHeaderMenu = () => {
  const fetchHeaderMenu = async (language: string) => {
    const cache = getCache(`header-nav-${language}`)

    const variables: GetSharedMenuItemsQueryVariables = {
      language: language === 'en' ? '' : `${language}/*`
    }

    if (cache.value.data) return cache.value.data

    return fetchGql(getSharedMenuItems, variables).then(async (response: any) => {
      return (cache.value.data = parseData(response.MenuItems.items, variables.language))
    })
  }

  return { fetchHeaderMenu }
}
